/*eslint no-unused-expressions: [2, { allowTernary: true }]*/
import React, {
  useEffect,
  useState,
  useRef,
  useReducer,
} from "react";
import { Layout, Button, Card, Row, Col, Spin, Input } from "antd";
import { get } from "lodash";
import { ProgressBar, PlaybackControls } from "./ProgressBar";
import BirdsEyeView from "./BirdsEyeView";
import Modal from "./Modal";
import "./Home.css";
import { VehiclePane } from "./DetailsPane";
import dataReducer from "./dataReducer";
import useAnimationFrame from "./hooks/useAnimationFrame";
import {
  saveToDatabase,
  // generateReport,
  deleteDatabase,
} from "./UserFunctions";

const { Content } = Layout;
const gridStyle = (width, height) => ({
  width,
  height,
});

const vehDetailsInit = {
  0: {
    timestamp: 0,
    speed: 0,
    yawrate: 0,
    long_accelaration: 0,
    lateral_accelaration: 0,
    steering_wheel_angle: 0,
    lka_right_status: 0,
    lka_left_status: 0,
  },
};

export default function Landing() {
  // states
  const [isPlaying, setIsPlaying] = useState(false);
  const loading = false;
  const loadingTip = "Loading...";
  const [value, setValue] = useState(0);
  const [blfValue, setBlfValue] = useState(0);
  const [duration, setDuration] = useState(0);
  const timeline = useRef([0]);
  const disableButtons = useRef(false);
  const currentTimeRef = useRef(0);
  const currentDelinkTimeRef = useRef(0);
  const [source, setSource] = useState();
  const [currentTime, setCurrentTime] = useState(0);
  const [prevFrameNumber, setPrevFrame] = useState(-1);
  const isPlayingRef = useRef(false);
  const isDelink = useRef(false);
  const [retrospectiveFrameSrc, setRetrospectiveFrameSrc] = useState([]);
  const [delink, setDelink] = useState(false);
  const [inputFrame, setInputFrame] = useState(0);
  const [showpopup, setShowpopup] = useState(true);
  const conflictFlag = useRef(false);
  const eventState = useRef("");
  const [videoName, setVideoName] = useState("");
  const [prevLkaLeft, setPrevLkaLeft] = useState("");
  const [prevLkaRight, setPrevLkaRight] = useState("");
  const [prevTime, setPrevTime] = useState("");
  const [leftCount, setLeftCount] = useState(0);
  const [rightCount, setRightCount] = useState(0);
  const [tpfpStatus, setTpFpStatus] = useState("");
  const [startTime, setStartTime] = useState("");
  const [username, setUserName] = useState("");
  const [data, dispatch] = useReducer(dataReducer, {
    bew: { 0: null },
    vehDetails: { 0: vehDetailsInit },

  });
  const [selectedObject, setSelectedObject] = useState(null);
  // const [objDetails, setObjDetails] = useState({
  //   obj: 0,
  //   objId: 0,
  //   longitude: 0,
  //   conf_twowheel: 0,
  //   conf_fourwheel: 0,
  //   conf_pedestrian: 0,
  //   conf_stationary: 0,
  //   obj_type: 0,
  //   conf_obj: 0,
  // });
 let clickcount = useRef(0);
 let eventCounter =() =>{
	clickcount.current ++;
}
  const handleTp = () => {
    setTpFpStatus('TP')
	let timeTP;
	let frameNumber;
	let seconds;
	if(eventState.current==="start"){
		frameNumber = currentTimeRef.current;
		seconds = value;
		timeTP = blfValue;
}else if(eventState.current==="stop"){
		frameNumber = currentTimeRef.current-1;
		seconds = timeline.current[currentTimeRef.current-1];
		timeTP = timeline.current[currentDelinkTimeRef.current-1];		
}
  
    const eventTime = data.vehDetails[timeTP].event_time;
    let event_count = clickcount.current;
    let dur = duration;
    const videoDuration = new Date(dur * 1000).toISOString().substr(11, 8);
    const frameTime = new Date(seconds * 1000).toISOString().substr(11, 12);
    const status = "TP";
    const leftStatus = data.vehDetails[timeTP].lka_left_status;
    const rightStatus = data.vehDetails[timeTP].lka_right_status;
    const extInputCmd = data.vehDetails[timeTP].ext_input_cmd;
    const laneWidth = data.vehDetails[timeTP].lane_width;
    const vehiclePosition = data.vehDetails[timeTP].vehicle_position;
    const timeStamp = data.vehDetails[timeTP].timestamp;
    const yawRate = data.vehDetails[timeTP].yawrate;
    const vehicleSpeed = data.vehDetails[timeTP].speed;
    const longitudinalAcceleration = data.vehDetails[timeTP].long_accelaration;
    const lateralAcceleration = data.vehDetails[timeTP].lateral_accelaration;
    const steeringWheelAngle = data.vehDetails[timeTP].steering_wheel_angle;
    const rightLane = data.vehDetails[timeTP].right_lane;
    const leftLane = data.vehDetails[timeTP].left_lane;
    const ldwRight = data.vehDetails[timeTP].ldw_right;
    const ldwLeft = data.vehDetails[timeTP].ldw_left;
    const userName = username;
    const maxExtInputCmd = data.vehDetails[timeTP].max_ext_input_cmd;
    const outputData = {
      event_count,
      frameNumber,
      videoName,
      videoDuration,
      frameTime,
      eventTime,
      status,
      leftStatus,
      rightStatus,
      extInputCmd,
      laneWidth,
      vehiclePosition,
      timeStamp,
      yawRate,
      vehicleSpeed,
      longitudinalAcceleration,
      lateralAcceleration,
      steeringWheelAngle,
      rightLane,
      leftLane,
      ldwRight,
      ldwLeft,
      userName,
      maxExtInputCmd
    };
    console.log(outputData)
    saveToDatabase(outputData, `${window.location.origin}/tpfp`).then(
      (response) => {
        if (response && response.status === 200) {
          console.log(response);
          if (timeline.current.length - 1 !== currentTimeRef.current && conflictFlag.current === false) {
          	handlePlay()
      	}else if(conflictFlag.current === true){
      	  conflictFlag.current = false
          eventState.current = "start"
      	}
        } else {
          alert("Database is not connected!!");
        }
      }
    );
    //console.log(outputData);

  };
  const handleFp = () => {
    setTpFpStatus('FP')
	let timeFP;
	let frameNumber;
	let seconds;
	if(eventState.current==="start"){
		frameNumber = currentTimeRef.current;
		seconds = value;
		timeFP = blfValue;
}else if(eventState.current==="stop"){
		frameNumber = currentTimeRef.current-1;
		seconds = timeline.current[currentTimeRef.current-1];
		timeFP = timeline.current[currentDelinkTimeRef.current-1];		
}	
    const eventTime = data.vehDetails[timeFP].event_time;
    let event_count = clickcount.current;
    let dur = duration;
    const videoDuration = new Date(dur * 1000).toISOString().substr(11, 8);
    const frameTime = new Date(seconds * 1000).toISOString().substr(11, 12);
    const status = "FP";
    const leftStatus = data.vehDetails[timeFP].lka_left_status;
    const rightStatus = data.vehDetails[timeFP].lka_right_status;
    const extInputCmd = data.vehDetails[timeFP].ext_input_cmd;
    const laneWidth = data.vehDetails[timeFP].lane_width;
    const vehiclePosition = data.vehDetails[timeFP].vehicle_position;
    const timeStamp = data.vehDetails[timeFP].timestamp;
    const yawRate = data.vehDetails[timeFP].yawrate;
    const vehicleSpeed = data.vehDetails[timeFP].speed;
    const longitudinalAcceleration = data.vehDetails[timeFP].long_accelaration;
    const lateralAcceleration = data.vehDetails[timeFP].lateral_accelaration;
    const steeringWheelAngle = data.vehDetails[timeFP].steering_wheel_angle;
    const rightLane = data.vehDetails[timeFP].right_lane;
    const leftLane = data.vehDetails[timeFP].left_lane;
    const ldwRight = data.vehDetails[timeFP].ldw_right;
    const ldwLeft = data.vehDetails[timeFP].ldw_left;
    const userName = username;
    const maxExtInputCmd = data.vehDetails[timeFP].max_ext_input_cmd;
    const outputData = {
      event_count,
      frameNumber,
      videoName,
      videoDuration,
      frameTime,
      eventTime,
      status,
      leftStatus,
      rightStatus,
      extInputCmd,
      laneWidth,
      vehiclePosition,
      timeStamp,
      yawRate,
      vehicleSpeed,
      longitudinalAcceleration,
      lateralAcceleration,
      steeringWheelAngle,
      rightLane,
      leftLane,
      ldwRight,
      ldwLeft,
      userName,
      maxExtInputCmd
    };
    saveToDatabase(outputData, `${window.location.origin}/tpfp`).then(
      (response) => {
        if (response && response.status === 200) {
          console.log(response);
          if (timeline.current.length - 1 !== currentTimeRef.current && conflictFlag.current === false) {
          	handlePlay()
      	}else if(conflictFlag.current === true){
      	  conflictFlag.current = false
          eventState.current = "start"
      	}
        } else {
          alert("Database is not connected!!");
        }
      }
    );
    console.log(outputData);
  };

  const undo_changes = () => {
    console.log(videoName);
    const frameNumber = currentTimeRef.current;
    deleteDatabase(
      { videoName, frameNumber },
      `${window.location.origin}/delete_database`
    ).then((response) => {
      if (response && response.status === 200) {
        console.log(response);
      }
    });
  };


  // const downloadReport = () => {
  //   console.log(videoName);
  //   generateReport(
  //     { videoName: videoName },
  //     `${window.location.origin}/download_csv`
  //   ).then((response) => {
  //     if (response && response.status === 200) {
  //       console.log(response);
  //       let fileName = response.headers["content-disposition"].split(
  //         "filename="
  //       )[1];
  //       console.log(fileName);
  //       const url = window.URL.createObjectURL(
  //         new Blob([response.data], {
  //           type:
  //             "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //         })
  //       );
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute(
  //         "download",
  //         response.headers["content-disposition"].split("filename=")[1]
  //       );
  //       document.body.appendChild(link);
  //       link.click();
  //     }
  //   });
  // };
  // dom refs
  const handlePlay = () => {
    if (timeline.current.length > 1) {
      isPlayingRef.current = true;
      setIsPlaying(true);
    }
  };

  const togglePopup = () => {
    setShowpopup(false);
  };

  const handlePause = () => {
    isPlayingRef.current = false;
    setIsPlaying(false);
  };

  const handleChange = (val) => {
    if (!isDelink.current) {
      currentDelinkTimeRef.current =
        currentDelinkTimeRef.current - currentTimeRef.current + val;
      setBlfValue(timeline.current[currentDelinkTimeRef.current]);
    }
    currentTimeRef.current = val;
    setValue(timeline.current[currentTimeRef.current]);
  };

  const prevFrame = () => {
    if (timeline.current.length >= 1 && currentTimeRef.current > 0) {
      currentTimeRef.current -= 1;
      setValue(timeline.current[currentTimeRef.current]);

      if (!isDelink.current) {
        currentDelinkTimeRef.current -= 1;
        setBlfValue(timeline.current[currentDelinkTimeRef.current]);
      }
    }
  };

  const onInputChange = (e) => {
    setInputFrame(e.target.value);
  };

  const submitInput = (e) => {
    e.preventDefault();
    handleChange(parseInt(inputFrame));
    setInputFrame(0);
  };

  const nextFrame = () => {
    if (
      timeline.current.length > 1 &&
      currentTimeRef.current < timeline.current.length
    ) {
      currentTimeRef.current += 1;
      setValue(timeline.current[currentTimeRef.current]);
      if (!isDelink.current) {
        currentDelinkTimeRef.current += 1;
        setBlfValue(timeline.current[currentDelinkTimeRef.current]);
      }
    }
  };

  const delinkBlf = () => {
    isDelink.current = !isDelink.current;
    setDelink(!delink);
  };
  // read samples.csv on first load

  const lka_right_status_func = () => {
    if(data.vehDetails[blfValue]['lka_right_status'] !== prevLkaRight ){
      if(data.vehDetails[blfValue]['lka_right_status']==="LKA Active for Right Side"){
        disableButtons.current=false
        setStartTime(data.vehDetails[blfValue]['updated_timestamp'])
        setRightCount(0)
        eventState.current = "start"
        handlePause()
      }else if(prevLkaRight === "LKA Active for Right Side"){
        disableButtons.current=true
        console.log("Start Time",startTime)
        console.log("End Time",prevTime)
        console.log("LKA Right Status Active",tpfpStatus,rightCount-1)
        setRightCount(0)
        eventState.current = "stop"
        handlePause()
      }else{
     disableButtons.current=true
   }
    }else if(data.vehDetails[blfValue]['lka_right_status']==="LKA Active for Right Side"&&prevLkaRight ==="LKA Active for Right Side"&&isPlayingRef.current){
        disableButtons.current=false
        if(tpfpStatus ==='TP'){
           handlePause()
           eventState.current = "start"
           handleTp();
        }else if(tpfpStatus ==='FP'){
           handlePause()
           eventState.current = "start"
           handleFp();
        }
   else{
     disableButtons.current=true
   }

  }

  };

  useEffect(() => {
    setCurrentTime(currentTimeRef.current);
    setInputFrame(currentTimeRef.current);
    if (showpopup !== true) {
      if (currentTimeRef.current < retrospectiveFrameSrc.length) {
        let filereader = new FileReader();
        filereader.addEventListener(
          "load",
          function () {
            if (this.result) {
              setSource(this.result);
            }
          },
          false
        );

        filereader.readAsDataURL(retrospectiveFrameSrc[currentTimeRef.current]);
      }
    }
if(currentTimeRef.current !== prevFrameNumber){
    if((prevLkaLeft==="LKA Active for Left Side"&& data.vehDetails[blfValue]['lka_right_status']==="LKA Active for Right Side" )||(prevLkaRight ==="LKA Active for Right Side" && data.vehDetails[blfValue]['lka_left_status']==="LKA Active for Left Side")){
        disableButtons.current=false
        setLeftCount(0)
        eventState.current = "stop"
        handlePause()
    }
   else{
   if(data.vehDetails[blfValue]['lka_left_status'] !== prevLkaLeft){
      if(data.vehDetails[blfValue]['lka_left_status']==="LKA Active for Left Side"){
        disableButtons.current=false
        setStartTime(data.vehDetails[blfValue]['updated_timestamp'])
        setLeftCount(0)
        eventState.current = "start"
        handlePause()
      }else if(prevLkaLeft === "LKA Active for Left Side"){
        disableButtons.current=true
        console.log("Start Time",startTime)
        console.log("End TIme",prevTime)
        console.log("LKA Left Status Active",tpfpStatus,leftCount-1)
        setLeftCount(0)
    eventState.current = "stop"
        handlePause()
      }else{
     disableButtons.current=true
   }
    }else if((data.vehDetails[blfValue]['lka_left_status']==="LKA Active for Left Side"&&prevLkaLeft==="LKA Active for Left Side"&&isPlayingRef.current)){
        disableButtons.current=false
        console.log(1)
        if(tpfpStatus ==='TP'){
           handlePause()
           handleTp();
        }else if(tpfpStatus ==='FP'){
           handlePause()
           handleFp();
        }
   }else{
     disableButtons.current=true
   }
   lka_right_status_func()

    }
    setPrevLkaLeft(data.vehDetails[blfValue]['lka_left_status'])
    setPrevLkaRight(data.vehDetails[blfValue]['lka_right_status'])
    setPrevTime(data.vehDetails[blfValue]['updated_timestamp'])
    setPrevFrame(currentTimeRef.current)
    }
  }, [value, data, isPlaying, tpfpStatus]);

  useEffect(() => {
    if (selectedObject && data.bew[value]) {
      const object = get(data.bew, [
        value,
        selectedObject.type,
        selectedObject.index,
      ]);
      if (!object) {
        return;
      }
      // setObjDetails({
      //   obj: selectedObject.type,
      //   objId: object.id,
      //   longitude: object.y,
      //   lateral: object.x,
      //   conf_twowheel: object.two_whl_conf,
      //   conf_fourwheel: object.four_whl_conf,
      //   conf_stationary: object.stationary_conf,
      //   conf_pedestrian: object.pedes_conf,
      //   conf_obj: object.conf_obj,
      //   obj_type: object.obj_type,
      // });
    }
  }, [selectedObject, data, value]);

  const renderScreen = (deltaTime) => {
    if (isPlayingRef.current) {
      currentTimeRef.current += 1;
      if (!isDelink.current) {
        currentDelinkTimeRef.current += 1;
        setBlfValue(timeline.current[currentDelinkTimeRef.current]);
      }
      if (timeline.current.length - 1 === currentTimeRef.current) {
        setIsPlaying(false);
        isPlayingRef.current = false;
      }
      setValue(timeline.current[currentTimeRef.current]);
    }
  };

  useAnimationFrame(renderScreen);

  // update progress bar regularly

  return (
    <Spin spinning={loading} tip={loadingTip}>
      <Layout>
        <div className="row">
          <div className="col-lg-12">
            <Layout
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflowY: "hidden",
              }}
            >
              <Content style={{ display: "flex" }}>
                <div
                  style={{
                    height: "103vh",
                    width: "40%",
                    backgroundColor: "#ffffff",
                    padding: 0,
                  }}
                >
                  <BirdsEyeView
                    data={data.bew[value]}
                    width={450}
                    height={275}
                    setSelectedObject={setSelectedObject}
                    selectedObject={selectedObject}
                  />
                  <Card
                    size="small"
                    title="BLF / CAN STATUS"
                    style={{
                      height: "60vh",
                      textAlign: "center",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <VehiclePane vehicalDetails={data.vehDetails[blfValue]} />
                  </Card>
                </div>
                <div
                  style={{
                    height: "170vh",
                    width: "60%",
                    backgroundColor: "#ffffff",
                    padding: 0,
                  }}
                >
                  <div
                    style={{
                      ...gridStyle("100%", "4%"),
                      border: "2px solid #aaa",
                      borderRight: "none",
                      padding: "0px",
                    }}
                  >
                    <Button
                      style={{
                        border: "2px solid #aaa",
                        backgroundColor: "blue",
                        color: "white",
                        fontWeight: "bold",
                        cursor: "pointer",
                        width: "100%",
                        height: "100%",
                      }}
                      onClick={handlePause}
                      href={
                        "http://0.0.0.0:3001/honda/polyline/polyline_tool/?frame=" +
                        currentTime
                      }
                      target="_blank"
                    >
                      Profiler Tool(Annotation)
                    </Button>
                  </div>
                  <div
                    style={{
                      ...gridStyle("100%", "38.5%"),
                      border: "2px solid #aaa",
                      borderTop: "none",
                      borderRight: "none",
                      padding: 0,
                    }}
                  >
                    <img
                      src={source}
                      alt=""
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <div
                    style={{
                      ...gridStyle("100%", "5%"),
                      border: "2px solid #aaa",
                      borderRight: "none",
                      padding: "0px",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "blue",
                        border: "0px",
                        borderRadius: "0px",
                        padding: "2px",
                        height: "100%",
                        color: "white",
                        fontWeight: "bold",
                        cursor: "pointer",
                        width: "49%",
                      }}
                      onClick={prevFrame}
                    >
                      Prev Frame
                    </Button>
                    <PlaybackControls
                      isPlaying={isPlaying}
                      onPlaybackChange={(playing) => {
                        if (playing) {
                          handlePlay();
                        } else {
                          handlePause();
                        }
                      }}
                    />
                    <Button
                      style={{
                        backgroundColor: "blue",
                        border: "0px",
                        borderRadius: "0px",
                        height: "100%",
                        padding: "2px",
                        color: "white",
                        fontWeight: "bold",
                        cursor: "pointer",
                        width: "49%",
                      }}
                      onClick={nextFrame}
                    >
                      Next Frame
                    </Button>
                  </div>
                  <div
                    style={{
                      ...gridStyle("100%", "5%"),
                      border: "2px solid #aaa",
                      borderRight: "none",
                      padding: "0px",
                    }}
                  >
                    <Input
                      value={inputFrame}
                      onChange={(e) => onInputChange(e)}
                      style={{ width: "90px", height: "100%" }}
                    />
                    <Button
                      style={{
                        backgroundColor: "blue",
                        padding: "2px",
                        color: "white",
                        height: "100%",
                        fontWeight: "bold",
                        cursor: "pointer",
                        width: "25.5%",
                      }}
                      onClick={submitInput}
                    >
                      Go to Frame
                    </Button>
                    <Button
                      style={{
                        padding: "2px",
                        width: "21%",
                        height: "100%",
                        fontWeight: "bold",
                        color: "white",
                        backgroundColor: "blue",
                      }}
                      disabled = {disableButtons.current}
                      onClick={()=>{eventCounter();handleTp()}}
                        //onClick={()=>{handleTp();clickcount()}}
                    >
                      TP
                    </Button>
                    <Button
                      style={{
                        padding: "2px",
                        width: "21%",
                        height: "100%",
                        fontWeight: "bold",
                        color: "white",
                        backgroundColor: "blue",
                      }}
                      disabled = {disableButtons.current}
                      onClick={()=>{eventCounter();handleFp()}}
			//onClick={()=>{handleFp();clickcount()}}
                    >
                      FP
                    </Button>
                    <Button
                      style={{
                        padding: "2px",
                        width: "19.3%",
                        height: "100%",
                        fontWeight: "bold",
                        color: "white",
                        backgroundColor: "blue",
                      }}
                      onClick={undo_changes}
                    >
                      UNDO
                    </Button>
                  </div>
                  <Row align="middle">
                    <Col>
                      <Input
                        value={value}
                        defaultValue="0.000"
                        disabled
                        style={{ width: "100px" }}
                      />
                    </Col>
                    <Col>
                      <Button
                        style={{
                          padding: "2px",
                          marginLeft: "12px",
                          width: "55px",
                        }}
                        onClick={delinkBlf}
                      >
                        {delink ? (
                          <span style={{ fontSize: "15px" }}>Link</span>
                        ) : (
                          <span style={{ fontSize: "15px" }}>Delink</span>
                        )}
                      </Button>
                    </Col>
                    <Col
                      flex={20}
                      style={{ padding: "2px", marginLeft: "12px" }}
                    >
                      <ProgressBar
                        value={currentTime}
                        onChange={(val) => {
                          setCurrentTime(val);
                          setInputFrame(val);
                          handleChange(val);
                        }}
                        step={1}
                        max={duration}
                      />
                    </Col>
                  </Row>
                </div>
              </Content>
            </Layout>
          </div>
          {showpopup ? (
            <Modal
              setRetrospectiveFrameSrc={setRetrospectiveFrameSrc}
              setSource={setSource}
              timeline={timeline}
              dispatch={dispatch}
              setVideoName={setVideoName}
              setDuration={setDuration}
              setUserName={setUserName}
              editSelectedRow={showpopup}
              handleEditModalClose={togglePopup}
            />
          ) : undefined}
        </div>
      </Layout>
    </Spin>
  );
}

